import React, { useCallback, useEffect, useRef, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import MaterialTable from '@material-table/core';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import { Add, AddToQueue, AlarmOn, Archive, Block, Check, Clear, Delete, Done, DoneAll, Edit, Print, Publish, Refresh, RemoveFromQueue, Save, Unarchive } from '@material-ui/icons';
import HistoryIcon from '@material-ui/icons/History';
import axios_instance from '../../../services/auth/jwt/config';
import sweetAlert from '../../../f5/utils/sweetAlert';
import { Backdrop, Box, Button, ButtonGroup, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, GridSize, InputLabel, MenuItem, Paper, Select, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import ImagePreview from '../../../f5/ImagePreview';
import _ from 'lodash';
import DialogEditOrdem from './DialogEditOrdem';
import DialogHistoryOrdem from './DialogHistoryOrdem';
import DialogPrintOrdem from './DialogPrintOrdem';
import moment from 'moment';
import { KeyboardDatePicker } from '@material-ui/pickers';
import DialogMultiPrintOrdem from './DialogMultiPrintOrdem';
import DialogExportOrdem from './DialogExportOrdem';

interface ObraOrderIndexProps {

}

type Status = {
    id: number,
    nome: string,
    interno: string
}

export type History = {
    message: string,
    old_status: Status,
    new_status: Status,
    user: {
        nome: string
    },
    created_at: string
}

export type Ordem = {
    id: number,
    solicitante?: string | null,
    telefone?: string | null,
    celular?: string | null,
    local?: string | null,
    endereco?: string | null,
    protocolo?: string,
    descricao?: string | null,
    intervencao?: string | null,
    materiais_equipamentos?: string | null,
    observacao?: string | null,
    archived: boolean,
    prazo?: string | null,
    comeco_at?: string | null,
    termino_at?: string | null,
    finalizado_at?: string | null,
    empresa_id?: number | null,
    empresa?: Empresa | null,
    terceiro?: boolean | number,
    is_terceiro?: boolean | number,
    terceirizado?: boolean | number,
    ocorrencia_id?: number | null,
    tipo_id: number,
    aberto_id: number,
    atendente_id: number,
    status_id: number,
    entrada_id?: number | null,
    self?: boolean,
    data: {
        [key: string]: string | number | null
    },
    anexos?: {
        uuid: string
    }[],
    history?: History[],
    status?: Status,
    created_at?: string,
    aberto?: {
        nome: string
    },
    tipo?: {
        nome: string
    },
    atendentes?: {
        id: number,
        nome: string,
        pivot: {
            principal: boolean
        }
    }[]
}

export type Setor = {
    nome: string,
    com_analise?: boolean,
    com_terceiro?: boolean,
    hide_fields: {
        [key: string]: boolean
    },
    translate: {
        [key: string]: string
    },
    columns?: any[],
    enable_actions: {
        [key: string]: boolean
    },
    end_mode: 'a_finalizar' | null,
}

type Empresa = {
    id: number,
    nome: string,
}

export type Field = {
    name: string,
    description: string,
    slug: string,
    required: boolean,
    default?: string,
    type: 'text' | 'number' | 'date' | 'select' | 'checkbox' | 'multiline' | 'multiselect',
    edit_level: number,
    order: number,
    size: GridSize | undefined,
    options?: string[],
}

export default function ObraOrderIndex({ ...props }: ObraOrderIndexProps) {
    const [tipos, setTipos] = useState<any[]>([]);
    const [entradas, setEntradas] = useState<any[]>([]);
    const [empresas, setEmpresas] = useState<Empresa[]>([]);
    const [loading, setLoading] = useState<boolean>(false)
    const [sending, setSending] = useState<boolean>(false)
    const [loadingEmpresas, setLoadingEmpresas] = useState<boolean>(false)
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [mode, setMode] = useState<'add' | 'edit' | 'view'>('add')
    const [newAnexos, setNewAnexos] = useState<any[]>([])
    const [openHistory, setOpenHistory] = useState({ open: false, id: 0 })
    const [openExport, setOpenExport] = useState(false)
    const [canTerceiro, setCanTerceiro] = useState(false)
    const [setor, setSetor] = useState<Setor>({
        nome: '',
        hide_fields: {},
        translate: {},
        enable_actions: {},
        end_mode: null,
    })
    const [openPrint, setOpenPrint] = useState<{ open: boolean, data: Ordem | null }>({ open: false, data: null })
    const [openMultiPrint, setOpenMultiPrint] = useState(false)
    const [openTerceiro, setOpenTerceiro] = useState<{ open: boolean, id: number }>({ open: false, id: 0 })
    const [empresaId, setEmpresaId] = useState<number | ''>('')
    const [columns, setColumns] = useState<any[]>([
        { title: 'Protocolo', field: 'protocolo' },
        { title: 'Nome', field: 'solicitante' },
        { title: 'Tipo', field: 'tipo.nome' },
        { title: 'Data abertura', field: 'created_at', type: 'date' },
        { title: 'Status', field: 'status.nome' },
        { title: 'Prazo', field: 'prazo', type: 'date', emptyValue: 'Sem Prazo' },
    ])
    const [counters, setCounters] = useState({
        aberto: 0,
        em_andamento: 0,
        finalizado: 0,
        cancelado: 0,
        a_finalizar: 0,
        em_analise: 0,
        sem_terceiro: 0,
        com_terceiro: 0,
    })
    const [toPrint, setToPrint] = useState<Ordem[]>([])
    const [status, setStatus] = useState<any[]>([])
    const [filterTerceiro, setFilterTerceiro] = useState(false)
    const [filter, setFilter] = useState<string>('aberto')
    const [filterTipo, setFilterTipo] = useState<string>('')
    const [filterEntrada, setFilterEntrada] = useState<string>('')
    const [filterAtendente, setFilterAtendente] = useState<string>('')
    const [filterAberturaInicio, setFilterAberturaInicio] = useState<string>('')
    const [filterAberturaFim, setFilterAberturaFim] = useState<string>('')
    const [filterAberturaPeriodo, setFilterAberturaPeriodo] = useState<string>('')
    const [tecnicos, setTecnicos] = useState<any[]>([])
    const [tecnicoPrincipal, setTecnicoPrincipal] = useState<any>(null)
    const [tecnicosAuxiliares, setTecnicosAuxiliares] = useState<any[]>([])
    const [fields, setFields] = useState<Field[]>([])
    const [editing, setEditing] = useState<Ordem>({
        id: 0,
        solicitante: '',
        telefone: '',
        celular: '',
        local: '',
        endereco: '',
        descricao: '',
        intervencao: '',
        materiais_equipamentos: '',
        observacao: '',
        data: {},
        archived: false,
        prazo: null,
        comeco_at: null,
        termino_at: null,
        finalizado_at: null,
        tipo_id: 0,
        aberto_id: 0,
        atendente_id: 0,
        status_id: 0,
        entrada_id: 0,
    })
    const table = useRef(null)
    const auth = useSelector(({ auth }: any) => (auth.authUser ? auth.authUser.cargo.interno : null));
    const authId = useSelector(({ auth }: any) => (auth.authUser ? auth.authUser.id : null));

    const onLoad = () => {
        if (table.current) {
            // @ts-ignore
            table.current.onQueryChange()
            onLoadCounter()
        }
    }

    const onChangeAberturaPeriodo = (periodo: string) => {
        setFilterAberturaPeriodo(periodo)

        if (!periodo) {
            setFilterAberturaInicio('')
            setFilterAberturaFim('')
            return
        }

        const hoje = moment()
        let inicio = hoje.clone()
        const fim = hoje.clone()

        switch (periodo) {
            case 'ultima-semana':
                inicio.subtract(6, 'days')
                break
            case 'ultimos-15-dias':
                inicio.subtract(14, 'days')
                break
            case 'ultimo-mes':
                inicio.subtract(1, 'month')
                break
            case 'esse-mes':
                inicio.startOf('month')
                break
            case 'essa-semana':
                inicio.startOf('isoWeek')
                break
            default:
                return
        }

        setFilterAberturaInicio(inicio.format('YYYY-MM-DD'))
        setFilterAberturaFim(fim.format('YYYY-MM-DD'))
    }

    const onLoadCounter = useCallback((warn = false) => {
        axios_instance.get<{ success: boolean, can_terceiro: boolean, alert: number, setor: Setor, fields: Field[], counter: any, message: string, status: any[], entradas: any[], tipos: any[], tecnicos: any[] }>(`obra/ordem_servico/counter`, {
            params: {
                atendente: filterAtendente ?? null,
                tipo: filterTipo ?? null,
                entrada: filterEntrada ?? null,
                tercerio: filterTerceiro ? 1 : 0,
                abertura_inicio: filterTerceiro ? filterAberturaInicio || null : null,
                abertura_fim: filterTerceiro ? filterAberturaFim || null : null,
            }
        }).then((response) => {
            let r = response.data
            if (r.success) {
                setCounters(r.counter)
                setStatus(r.status)
                setTipos(r.tipos)
                setEntradas(r.entradas)
                setTecnicos(r.tecnicos)
                setFields(r?.fields ?? [])
                setCanTerceiro(r?.can_terceiro ?? false)
                setSetor(r?.setor ?? { nome: '', hide_fields: {}, translate: {}, enable_actions: {} })
                if (r?.setor?.columns && r?.setor?.columns.length > 0) {
                    setColumns(r?.setor?.columns)
                }
                if (warn) {
                    if (r.alert > 0) {
                        sweetAlert('warning', 'Atenção', `Existem ${r.alert} ordens de serviço abertas para você`)
                    }
                }
            } else {
                sweetAlert('error', 'Erro', r.message)
            }
        }).catch((error) => {
            sweetAlert('error', 'Erro', 'Erro ao carregar os contadores')
        })
    }, [filterAtendente, filterTipo, filterEntrada, filterTerceiro, filterAberturaInicio, filterAberturaFim])

    useEffect(() => {
        onLoad()
        const interval = setInterval(() => {
            onLoad()
        }, 60000)
        return () => clearInterval(interval)
    }, [filter, filterTipo, filterAtendente, filterEntrada, filterTerceiro, filterAberturaInicio, filterAberturaFim])

    useEffect(() => {
        onLoadCounter(true)
    }, [])

    const onChangeStatus = (rowData: any, status: string) => {
        setSending(true)
        axios_instance.post<{ success: boolean, message: string }>(`obra/ordem_servico/update/${rowData.id}`, {
            status: status
        }).then((response) => {
            let r = response.data
            if (r.success) {
                onLoad()
                onLoadCounter()
                sweetAlert('success', 'Sucesso', r.message)
            } else {
                sweetAlert('error', 'Erro', r.message)
            }
        }).catch((error) => {
            sweetAlert('error', 'Erro', 'Erro ao mudar o status da ordem de serviço')
        }).finally(() => {
            setSending(false)
        })
    }

    const onSave = () => {
        setSending(true)
        setOpenModal(false)
        if (!tecnicoPrincipal) {
            setSending(false)
            sweetAlert('error', 'Erro', 'Técnico Responsável é obrigatório', () => setOpenModal(true))
            return
        }
        if (!editing.tipo_id) {
            setSending(false)
            sweetAlert('error', 'Erro', 'Tipo é obrigatório', () => setOpenModal(true))
            return
        }

        let formData = new FormData()
        formData.append('solicitante', editing.solicitante || '')
        formData.append('telefone', editing.telefone || '')
        formData.append('celular', editing.celular || '')
        formData.append('local', editing.local || '')
        formData.append('endereco', editing.endereco || '')
        formData.append('created_at', editing.created_at || '')
        formData.append('descricao', editing.descricao || '')
        formData.append('intervencao', editing.intervencao || '')
        formData.append('materiais_equipamentos', editing.materiais_equipamentos || '')
        formData.append('observacao', editing.observacao || '')
        formData.append('tipo_id', editing.tipo_id.toString())
        formData.append('tecnicos[]', tecnicoPrincipal)
        formData.append('entrada_id', editing.entrada_id ? editing.entrada_id.toString() : '')
        if (editing.comeco_at) {
            formData.append('comeco_at', editing.comeco_at)
        } else {
            formData.append('comeco_at', '')
        }
        if (editing.termino_at) {
            formData.append('termino_at', editing.termino_at)
        } else {
            formData.append('termino_at', '')
        }
        if (editing.finalizado_at) {
            formData.append('finalizado_at', editing.finalizado_at)
        } else {
            formData.append('finalizado_at', '')
        }
        if (editing.data && Object.keys(editing.data).length > 0) {
            formData.append('data', JSON.stringify(editing.data))
        }
        for (let i = 0; i < tecnicosAuxiliares.length; i++) {
            formData.append('tecnicos[]', tecnicosAuxiliares[i])
        }
        formData.append('status_id', editing.status_id.toString())
        newAnexos.forEach((anexo, index) => {
            formData.append('anexos[]', anexo)
        })
        axios_instance.post<{ success: boolean, message: string }>(`obra/ordem_servico/save${editing.id === 0 ? '' : `/${editing.id}`}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            let r = response.data
            if (r.success) {
                onLoad()
                onLoadCounter()
                setNewAnexos([])
                sweetAlert('success', 'Sucesso', r.message)
            } else {
                sweetAlert('error', 'Erro', r.message, () => setOpenModal(true))
            }
        }).catch((error) => {
            sweetAlert('error', 'Erro', 'Erro ao salvar a ordem de serviço', () => setOpenModal(true))
        }).finally(() => {
            setSending(false)
        })
    }

    const loadEmpresas = () => {
        setLoadingEmpresas(true)
        axios_instance.get<{ success: boolean, data: Empresa[], message?: string }>('obra/ordem_servico/empresa/index').then((response) => {
            let r = response.data
            if (r.success) {
                setEmpresas(r.data)
            } else {
                sweetAlert('error', 'Erro', r?.message || 'Erro ao carregar as empresas')
            }
        }).catch(() => {
            sweetAlert('error', 'Erro', 'Erro ao carregar as empresas')
        }).finally(() => {
            setLoadingEmpresas(false)
        })
    }

    const onOpenTerceiro = (rowData: Ordem) => {
        setEmpresaId('')
        setOpenTerceiro({ open: true, id: rowData.id })
        loadEmpresas()
    }

    const onSaveTerceiro = () => {
        if (!empresaId) {
            sweetAlert('warning', 'Atenção', 'Selecione uma empresa')
            return
        }

        setSending(true)
        axios_instance.post<{ success: boolean, message: string }>(`obra/ordem_servico/atribuir/terceiro/${openTerceiro.id}`, {
            empresa_id: empresaId,
        }).then((response) => {
            let r = response.data
            if (r.success) {
                setOpenTerceiro({ open: false, id: 0 })
                setEmpresaId('')
                onLoad()
                onLoadCounter()
                sweetAlert('success', 'Sucesso', r.message)
            } else {
                sweetAlert('error', 'Erro', r.message)
            }
        }).catch(() => {
            sweetAlert('error', 'Erro', 'Erro ao atribuir ordem para empresa')
        }).finally(() => {
            setSending(false)
        })
    }

    const getActions = useCallback(() => {
        let isTecnico = auth === 'obras_tecnico'
        let isViewer = auth === 'obras_viewer'
        return [
            {
                icon: () => <Refresh />, tooltip: 'Atualizar', isFreeAction: true, onClick: () => {
                    onLoad();
                }
            },
            ((row: Ordem) => ({
                icon: () => <Edit />, tooltip: 'Editar', onClick: (_: any, rowData: Ordem) => {
                    setEditing(rowData)
                    setTecnicoPrincipal(rowData?.atendentes?.find((a: any) => a.pivot.principal)?.id || null)
                    setTecnicosAuxiliares(rowData?.atendentes?.filter((a: any) => !a.pivot.principal).map((a: any) => a.id) || [])
                    setMode('edit')
                    setOpenModal(true)
                }, disabled: isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0,
                hidden: isTecnico && !setor?.enable_actions?.edit || isViewer
            })),
            /* {
                icon: () => <Edit />, tooltip: 'Editar', onClick: (_: any, rowData: Ordem) => {
                    setEditing(rowData)
                    setTecnicoPrincipal(rowData?.atendentes?.find((a: any) => a.pivot.principal)?.id || null)
                    setTecnicosAuxiliares(rowData?.atendentes?.filter((a: any) => !a.pivot.principal).map((a: any) => a.id) || [])
                    setMode('edit')
                    setOpenModal(true)
                }, hidden: isTecnico
            }, */
            {
                icon: () => <HistoryIcon />, tooltip: 'Histórico', onClick: (_: any, rowData: Ordem) => {
                    setOpenHistory({ open: true, id: rowData.id })
                }, hidden: isTecnico && !setor?.enable_actions?.history
            },
            ((row: Ordem) => ({
                icon: () => <Check />, tooltip: 'Em Andamento', onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', 'Deseja realmente mudar o status desta ordem de serviço para "Em Andamento"?', () => {
                        onChangeStatus(rowData, 'em_andamento')
                    })
                }, disabled: row.status?.interno === 'em_andamento' || (isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0),
                hidden: isTecnico && !setor?.enable_actions?.check || isViewer
                //hidden: !isTecnico
            })),
            /* ((row: Ordem) => ({
                icon: () => <Check />, tooltip: 'Em Andamento', onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', 'Deseja realmente mudar o status desta ordem de serviço para "Em Andamento"?', () => {
                        onChangeStatus(rowData, 'em_andamento')
                    })
                }, disabled: row.status?.interno === 'em_andamento',
                hidden: isTecnico
            })), */
            ((row: Ordem) => ({
                icon: () => <AlarmOn />, tooltip: 'À Finalizar', onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', 'Deseja realmente marcar esta ordem de serviço como "À Finalizar"?', () => {
                        onChangeStatus(rowData, 'a_finalizar')
                    })
                }, disabled: row.status?.interno === 'a_finalizar' || (isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0),
                hidden: isTecnico && !setor?.enable_actions?.almost_done || isViewer || setor.end_mode != 'a_finalizar'
            })),
            ((row: Ordem) => ({
                icon: () => <DoneAll />, tooltip: 'Finalizar', onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', 'Deseja realmente finalizar esta ordem de serviço?', () => {
                        onChangeStatus(rowData, 'finalizado')
                    })
                }, disabled: row.status?.interno === 'finalizado' || (isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0),
                hidden: (isTecnico && !setor?.enable_actions?.done && !filterTerceiro) || isViewer
            })),
            ((row: Ordem) => ({
                icon: () => <Block />, tooltip: 'Cancelar', onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', 'Deseja realmente cancelar esta ordem de serviço?', () => {
                        onChangeStatus(rowData, 'cancelado')
                    })
                }, disabled: row.status?.interno === 'cancelado' || (isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0),
                hidden: (isTecnico && !setor?.enable_actions?.cancel && !filterTerceiro) || isViewer
            })),
            ((row: Ordem) => ({
                icon: () => <Publish />, tooltip: 'Atribuir para Empresa', onClick: (_: any, rowData: Ordem) => {
                    onOpenTerceiro(rowData)
                }, disabled: isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0,
                hidden: !canTerceiro || isViewer
            })),
            ((row: Ordem) => ({
                icon: () => row.archived ? <Unarchive /> : <Archive />, tooltip: row.archived ? 'Desarquivar' : 'Arquivar',
                onClick: (_: any, rowData: Ordem) => {
                    sweetAlert('warning', 'Atenção', `Deseja realmente ${row.archived ? 'desarquivar' : 'arquivar'} esta ordem de serviço?`, () => {
                        onChangeStatus(rowData, row.archived ? 'unarchive' : 'archive')
                    })
                }, disabled: (isTecnico && row.atendentes?.filter((a: any) => a.id === authId).length === 0),
                hidden: isTecnico && !setor?.enable_actions?.archive || isViewer
            })), {
                icon: () => <Print />, tooltip: 'Imprimir', onClick: (_: any, rowData: Ordem) => {
                    setOpenPrint({ open: true, data: rowData })
                },
                hidden: isTecnico && !setor?.enable_actions?.print
            }, ((row: Ordem) => ({
                icon: () => toPrint.findIndex((o) => o.id === row.id) === -1 ? <AddToQueue /> : <RemoveFromQueue />,
                tooltip: toPrint.findIndex((o) => o.id === row.id) === -1 ? 'Adicionar a lista de impressão' : 'Remover da lista de impressão',
                onClick: (_: any, rowData: Ordem) => {
                    if (toPrint.findIndex((o) => o.id === rowData.id) === -1) {
                        setToPrint((prev) => [...prev, rowData])
                    } else {
                        setToPrint((prev) => prev.filter((o) => o.id !== rowData.id))
                    }
                }, hidden: isTecnico && !setor?.enable_actions?.print_queue
            }))
        ];
    }, [auth, authId, setor, toPrint, canTerceiro, filterTerceiro])

    const canAdd = useCallback(() => {
        if (auth === 'obras_viewer') return false
        if (auth === 'obras_tecnico') {
            return setor?.enable_actions?.add
        }
        return true;
    }, [setor, auth])

    const onChangeFilter = (nextFilter: string) => {
        setFilter(nextFilter)
        onLoad()
    }

    // @ts-ignore
    return <PageContainer>
        <Grid container spacing={2} style={{ marginBottom: 10 }}>
            {setor.com_terceiro && canTerceiro ? <>
                <Grid item xs={6}>
                    <Paper
                        style={{ backgroundColor: '#4CAF50', color: 'white', outline: !filterTerceiro ? '2px solid black' : 'none', cursor: 'pointer' }}
                        onClick={() => {
                            setFilterTerceiro(false)
                            setFilterAberturaInicio('')
                            setFilterAberturaFim('')
                            onLoad()
                        }}
                    >
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row" gridGap={10} py={2}>
                            <Typography variant="h6">Interno</Typography>
                            <Typography variant="h6">{counters.sem_terceiro}</Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={6}>
                    <Paper
                        style={{ backgroundColor: '#FFC107', color: 'white', outline: filterTerceiro ? '2px solid black' : 'none', cursor: 'pointer' }}
                        onClick={() => {
                            setFilterTerceiro(true)
                            onLoad()
                        }}
                    >
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="row" gridGap={10} py={2}>
                            <Typography variant="h6">Terceirizado</Typography>
                            <Typography variant="h6">{counters.com_terceiro}</Typography>
                        </Box>
                    </Paper>
                </Grid>
            </> : null}
            {setor.com_analise && auth !== 'obras_tecnico' ? <Grid item xs={12} md={3} lg={2}>
                <Paper
                    style={{ backgroundColor: '#9C27B0', color: 'white', outline: filter === 'analise' ? '2px solid black' : 'none', cursor: 'pointer' }}
                    onClick={() => onChangeFilter('em_analise')}
                >
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">Em Análise</Typography>
                        <Typography variant="h2">{counters.em_analise}</Typography>
                    </Box>
                </Paper>
            </Grid> : null}
            <Grid item xs={12} md={3} lg={2}>
                <Paper
                    style={{ backgroundColor: '#4CAF50', color: 'white', outline: filter === 'aberto' ? '2px solid black' : 'none', cursor: 'pointer' }}
                    onClick={() => onChangeFilter('aberto')}
                >
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">Aberto</Typography>
                        <Typography variant="h2">{counters.aberto}</Typography>
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
                <Paper style={{ backgroundColor: '#FFC107', outline: filter === 'em_andamento' ? '2px solid black' : 'none', cursor: 'pointer' }}
                    onClick={() => onChangeFilter('em_andamento')}>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">Em Andamento</Typography>
                        <Typography variant="h2">{counters.em_andamento}</Typography>
                    </Box>
                </Paper>
            </Grid>
            {setor.end_mode == 'a_finalizar' ? <Grid item xs={12} md={3} lg={2}>
                <Paper style={{ backgroundColor: '#FF9800', outline: filter === 'a_finalizar' ? '2px solid black' : 'none', cursor: 'pointer' }} onClick={() => onChangeFilter('a_finalizar')}>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">A Finalizar</Typography>
                        <Typography variant="h2">{counters.a_finalizar}</Typography>
                    </Box>
                </Paper>
            </Grid> : null}
            <Grid item xs={12} md={3} lg={2}>
                <Paper style={{ backgroundColor: '#2196F3', outline: filter === 'finalizado' ? '2px solid black' : 'none', cursor: 'pointer' }} onClick={() => onChangeFilter('finalizado')}>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">Finalizado</Typography>
                        <Typography variant="h2">{counters.finalizado}</Typography>
                    </Box>
                </Paper>
            </Grid>
            {auth !== 'obras_tecnico' ? <Grid item xs={12} md={2}>
                <Paper style={{ backgroundColor: '#F44336', color: 'white', outline: filter === 'cancelado' ? '2px solid black' : 'none', cursor: 'pointer' }} onClick={() => onChangeFilter('cancelado')}>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Typography variant="h6">Cancelado</Typography>
                        <Typography variant="h2">{counters.cancelado}</Typography>
                    </Box>
                </Paper>
            </Grid> : null}
            {auth !== 'obras_tecnico' ? <Grid item xs={12} md={1}>
                <Paper style={{ backgroundColor: '#5a1814', color: 'white', outline: filter === 'archive' ? '2px solid black' : 'none', cursor: 'pointer' }} onClick={() => onChangeFilter('archive')}>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" py={2}>
                        <Archive />
                        <Typography variant="h6">Arquivo</Typography>
                    </Box>
                </Paper>
            </Grid> : null}
        </Grid>
        <Paper>
            <Box display="flex" justifyContent="space-between" p={2}>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>Ordens de Serviço</Typography>
                <Box display="flex" justifyContent="center" alignItems="center">
                    {auth !== 'obras_tecnico' ? <Button
                        variant="contained"
                        color="secondary"
                        style={{ marginRight: 10 }}
                        onClick={() => setOpenExport(true)}
                    >
                        Exportar
                    </Button> : null}
                    {canAdd() ? <Button
                        variant="contained"
                        onClick={() => {
                            setOpenModal(true)
                            setMode('add')
                            setNewAnexos([])
                            setEditing({
                                id: 0,
                                solicitante: '',
                                telefone: '',
                                celular: '',
                                local: '',
                                endereco: '',
                                descricao: '',
                                intervencao: '',
                                materiais_equipamentos: '',
                                observacao: '',
                                archived: false,
                                prazo: null,
                                comeco_at: null,
                                termino_at: null,
                                finalizado_at: null,
                                data: {},
                                tipo_id: 0,
                                aberto_id: 0,
                                atendente_id: 0,
                                status_id: 0,
                                entrada_id: 0,
                                empresa_id: filterTerceiro ? 1 : null,
                                terceiro: filterTerceiro,
                            })
                            setTecnicoPrincipal(null)
                            setTecnicosAuxiliares([])
                        }}
                        style={{ backgroundColor: '#4caf50', color: 'white' }}
                    >
                        Abrir Ordem de Serviço
                    </Button> : null}
                </Box>
            </Box>
            {auth !== 'obras_tecnico' ? <Box p={2}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel >{setor?.translate?.tecnico ?? "Técnico"}</InputLabel>
                            <Select
                                value={filterAtendente}
                                onChange={(e) => {
                                    //@ts-ignore
                                    setFilterAtendente(e.target.value)
                                    onLoad()
                                }}
                                label={setor?.translate?.tecnico ?? "Técnico"}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {tecnicos.map((t, index) => (
                                    <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel >{setor?.translate?.tipo ?? "Tipo de Serviço"}</InputLabel>
                            <Select
                                value={filterTipo}
                                onChange={(e) => {
                                    //@ts-ignore
                                    setFilterTipo(e.target.value)
                                    onLoad()
                                }}
                                label={setor?.translate?.tipo ?? "Tipo de Serviço"}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {tipos.map((t, index) => (
                                    <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel >{setor?.translate?.entrada ?? "Entrada"}</InputLabel>
                            <Select
                                value={filterEntrada}
                                onChange={(e) => {
                                    //@ts-ignore
                                    setFilterEntrada(e.target.value)
                                    onLoad()
                                }}
                                label={setor?.translate?.entrada ?? "Entrada"}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {entradas.map((t, index) => (
                                    <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {filterTerceiro ? <>
                        <Grid item xs={12} md={3}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Período</InputLabel>
                                <Select
                                    value={filterAberturaPeriodo}
                                    onChange={(e: any) => {
                                        let value = e?.target?.value ?? ''
                                        onChangeAberturaPeriodo(value)
                                    }}
                                    label="Período"
                                >
                                    <MenuItem value="">Personalizado</MenuItem>
                                    <MenuItem value="ultima-semana">Última semana</MenuItem>
                                    <MenuItem value="ultimos-15-dias">Últimos 15 dias</MenuItem>
                                    <MenuItem value="ultimo-mes">Último mês</MenuItem>
                                    <MenuItem value="esse-mes">Esse mês</MenuItem>
                                    <MenuItem value="essa-semana">Essa semana</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <KeyboardDatePicker
                                label="Abertura a partir de"
                                format="DD/MM/YYYY"
                                inputVariant="outlined"
                                fullWidth
                                value={filterAberturaInicio ? moment(filterAberturaInicio).toDate() : null}
                                onChange={(date) => {
                                    setFilterAberturaPeriodo('')
                                    setFilterAberturaInicio(date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '')
                                }}
                                maxDate={filterAberturaFim ? moment(filterAberturaFim).toDate() : undefined}
                                clearable
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <KeyboardDatePicker
                                label="Abertura até"
                                format="DD/MM/YYYY"
                                inputVariant="outlined"
                                fullWidth
                                value={filterAberturaFim ? moment(filterAberturaFim).toDate() : null}
                                onChange={(date) => {
                                    setFilterAberturaPeriodo('')
                                    setFilterAberturaFim(date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '')
                                }}
                                minDate={filterAberturaInicio ? moment(filterAberturaInicio).toDate() : undefined}
                                clearable
                            />
                        </Grid>
                    </> : null}
                    <Grid item xs={12} md={3}>
                        <Box display="flex" justifyContent="flex-end">
                            <ButtonGroup>
                                {toPrint.length > 0 ? <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Print />}
                                    onClick={() => setOpenMultiPrint(true)}
                                    fullWidth
                                >
                                    Imprimir ({toPrint.length} ordens)
                                </Button> : null}
                                {toPrint.length > 0 ? <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => setToPrint([])}
                                >
                                    <Clear />
                                </Button> : null}
                            </ButtonGroup>
                        </Box>
                    </Grid>
                </Grid>
            </Box> : <Box p={2}>
                <Grid container spacing={2} alignItems='center'>
                    {filterTerceiro ? <>
                        <Grid item xs={12} md={3}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Período</InputLabel>
                                <Select
                                    value={filterAberturaPeriodo}
                                    onChange={(e: any) => {
                                        let value = e?.target?.value ?? ''
                                        onChangeAberturaPeriodo(value)
                                    }}
                                    label="Período"
                                >
                                    <MenuItem value="">Personalizado</MenuItem>
                                    <MenuItem value="ultima-semana">Última semana</MenuItem>
                                    <MenuItem value="ultimos-15-dias">Últimos 15 dias</MenuItem>
                                    <MenuItem value="ultimo-mes">Último mês</MenuItem>
                                    <MenuItem value="esse-mes">Esse mês</MenuItem>
                                    <MenuItem value="essa-semana">Essa semana</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <KeyboardDatePicker
                                label="Abertura a partir de"
                                format="DD/MM/YYYY"
                                inputVariant="outlined"
                                fullWidth
                                value={filterAberturaInicio ? moment(filterAberturaInicio).toDate() : null}
                                onChange={(date) => {
                                    setFilterAberturaPeriodo('')
                                    setFilterAberturaInicio(date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '')
                                }}
                                maxDate={filterAberturaFim ? moment(filterAberturaFim).toDate() : undefined}
                                clearable
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <KeyboardDatePicker
                                label="Abertura até"
                                format="DD/MM/YYYY"
                                inputVariant="outlined"
                                fullWidth
                                value={filterAberturaFim ? moment(filterAberturaFim).toDate() : null}
                                onChange={(date) => {
                                    setFilterAberturaPeriodo('')
                                    setFilterAberturaFim(date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '')
                                }}
                                minDate={filterAberturaInicio ? moment(filterAberturaInicio).toDate() : undefined}
                                clearable
                            />
                        </Grid>
                    </> : null}
                </Grid>
            </Box>}
            <MaterialTable
                title=""
                tableRef={table}
                options={{
                    rowStyle: (rowData: any) => {
                        let bgColor = '#fff'
                        if (rowData.prazo) {
                            let diasPrazo = moment(rowData.prazo).diff(moment(), 'days')
                            if (diasPrazo < 0) {
                                bgColor = '#ff7a7a'
                            } else if (diasPrazo <= 5) {
                                bgColor = '#f8fa70'
                            }
                        }
                        if (toPrint.findIndex((o) => o.id === rowData.id) !== -1) {
                            bgColor = '#7aff7a'
                        }
                        return { backgroundColor: bgColor }
                    }
                }}
                columns={columns}
                isLoading={loading}
                data={(query: any) =>
                    new Promise<any>((resolve, reject) => {
                        let url = 'obra/ordem_servico/index'
                        axios_instance
                            .get<any>(url, {
                                params: {
                                    search: query?.search ?? undefined,
                                    order_by: query?.orderBy?.field ?? undefined,
                                    order: query?.orderDirection ?? undefined,
                                    page: query?.page + 1,
                                    per_page: query?.pageSize,
                                    status: filter,
                                    terceiro: filterTerceiro ? 1 : 0,
                                    abertura_inicio: filterTerceiro ? filterAberturaInicio || undefined : undefined,
                                    abertura_fim: filterTerceiro ? filterAberturaFim || undefined : undefined,
                                    atendente: filterAtendente ?? undefined,
                                    tipo: filterTipo ?? undefined,
                                    entrada: filterEntrada ?? undefined,
                                }
                            })
                            .then(response => {
                                let r = response.data;
                                if (r.success) {
                                    resolve({
                                        data: r.data.data,
                                        page: r.data.current_page - 1,
                                        totalCount: r.data.total,
                                    });
                                }
                            })
                            .catch(() => {
                                reject();
                            });
                    })}
                components={{
                    Container: props => <Paper {...props} elevation={0} />,
                }}
                onRowClick={(_, rowData) => {
                    if (rowData) {
                        setEditing({
                            ...rowData,
                            data: rowData?.data ?? {},
                        })
                        setTecnicoPrincipal(rowData?.atendentes?.find((a: any) => a.pivot.principal)?.id || null)
                        setTecnicosAuxiliares(rowData?.atendentes?.filter((a: any) => !a.pivot.principal).map((a: any) => a.id) || [])
                        setMode('view')
                        setOpenModal(true)
                    }
                }}
                // @ts-ignore
                actions={getActions()}
                localization={tableLocalization}
                icons={tableIcons}
            />
        </Paper>
        <Backdrop open={sending} style={{ zIndex: 9999 }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%" color="white">
                <CircularProgress />
                <Typography variant="h6" style={{ marginLeft: 10 }}>Enviando...</Typography>
            </Box>
        </Backdrop>
        <DialogEditOrdem
            fields={fields}
            setor={setor}
            open={openModal}
            entradas={entradas}
            isTerceiro={filterTerceiro}
            onClose={() => {
                setOpenModal(false)
                setNewAnexos([])
            }}
            editing={editing}
            onChange={setEditing}
            onSave={onSave}
            mode={mode}
            tipos={tipos}
            status={status}
            tecnicos={tecnicos}
            anexos={newAnexos}
            onChangeAnexos={setNewAnexos}
            tecnicoPrincipal={tecnicoPrincipal}
            setTecnicoPrincipal={setTecnicoPrincipal}
            tecnicosAuxiliares={tecnicosAuxiliares}
            setTecnicosAuxiliares={setTecnicosAuxiliares}
        />
        <DialogHistoryOrdem
            open={openHistory.open}
            onClose={() => setOpenHistory({ open: false, id: 0 })}
            id={openHistory.id}
        />
        <DialogPrintOrdem
            open={openPrint.open}
            onClose={() => setOpenPrint({ open: false, data: null })}
            ordem={openPrint.data}
        />
        <DialogMultiPrintOrdem
            open={openMultiPrint}
            onClose={() => setOpenMultiPrint(false)}
            ordems={toPrint}
        />
        <Dialog
            open={openTerceiro.open}
            onClose={() => {
                setOpenTerceiro({ open: false, id: 0 })
                setEmpresaId('')
            }}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Atribuir para Empresa</DialogTitle>
            <DialogContent>
                <FormControl variant="outlined" fullWidth margin="normal" disabled={loadingEmpresas}>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                        value={empresaId}
                        onChange={(e) => {
                            // @ts-ignore
                            setEmpresaId(e.target.value)
                        }}
                        label="Empresa"
                    >
                        <MenuItem value="">Selecione</MenuItem>
                        {empresas.map((empresa) => (
                            <MenuItem key={empresa.id} value={empresa.id}>{empresa.nome}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        setOpenTerceiro({ open: false, id: 0 })
                        setEmpresaId('')
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    style={{ backgroundColor: '#4caf50', color: 'white' }}
                    onClick={onSaveTerceiro}
                    startIcon={<Save />}
                    disabled={!empresaId || loadingEmpresas}
                >
                    Atribuir
                </Button>
            </DialogActions>
        </Dialog>
        <DialogExportOrdem
            open={openExport}
            onClose={() => setOpenExport(false)}
            tecnicos={tecnicos}
            tecnico={setor?.translate?.tecnico ?? "Técnico"}
        />
    </PageContainer>
}